export default __webpack_public_path__ + "media/food.b1a4619b8b15c0979879b45f50650734.webp";